import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { AvailabilityBlockReportParameters, useRepositoryQuery } from '@mews-commander/data-access';
import { compactArray, primitiveTypeUniq } from '@mews/fp';
import { fetchAccountsByIds } from '@mews-commander/legacy-entities/src/actions';

export const useAvailabilityReportQuery = (params: AvailabilityBlockReportParameters) => {
    const dispatch = useDispatch();
    const query = useRepositoryQuery('availabilityBlockReport', 'get', params, {
        refetchOnMount: 'always',
    });

    useEffect(() => {
        if (!query.data) return;

        const accountIds = primitiveTypeUniq(
            compactArray(
                query.data.availabilityBlocks.flatMap((block) => [
                    block.travelAgencyId,
                    block.companyId,
                    block.bookerId,
                ])
            )
        );

        if (accountIds.length > 0) dispatch(fetchAccountsByIds({ accountIds }));
    }, [dispatch, query.data]);

    return query;
};
